<div *ngIf="goBack" class="top-bar">
	<a routerLink="/" class="back-btn"><i class="mdi mdi-reply"></i> <span> Back</span></a>
</div>
